import { Link } from 'react-router-dom';
import styles from './DEFooter.module.css';

export const links = [
  { label: 'Rechtliches', href: null },
  {
    label: 'Datenschutzhinweis',
    href: 'https://www.iwoca.de/compliance/datenschutzhinweis',
  },
  {
    label: 'Impressum',
    href: 'https://www.iwoca.de/compliance/impressum',
  },
  {
    label: 'Beschwerdeverfahren',
    href: 'https://iwoca.de/compliance/beschwerdeverfahren',
  },
] as const;

export const DEFooter = () => {
  return (
    <div className={styles.footer}>
      {links.map(({ label, href }) =>
        href ? (
          <Link key={label} to={href} className={styles.item}>
            {label}
          </Link>
        ) : (
          <span key={label} className={styles.item}>
            {label}
          </span>
        ),
      )}
    </div>
  );
};
